import React, { useEffect, useState } from "react";
import Stepper from "../../components/steper/Stepper";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../../redux/slices/authSlice";
import Loader from "../../components/Loader/Loader";
import { ImageUp, Trash } from "lucide-react";
import {
  uploadPanFront,
  uploadPanBack,
  uploadAadharFront,
  uploadAadharBack,
  uploadCheque,
} from "../../redux/slices/uploadSlice";
import { ShieldTick } from "iconsax-react";
import { updateMember } from "../../redux/slices/memberSlice";

const KYCDetailsFormMr = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const { loading } = useSelector((state) => state.auth);
  const previousData = location.state?.payload || {};
  const [memberId, setMemberId] = useState(null);
  const [errors, setErrors] = useState({});
  const [uploadStatuspan, setUploadStatuspan] = useState(false);
  const [uploadStatuspan2, setUploadStatuspan2] = useState(false);
  const [uploadAadhar, setuploadAadhar] = useState(false);
  const [uploadAadhar2, setuploadAadhar2] = useState(false);
  const [uploadChequeBook, setuploadChequeBook] = useState(false);
  // console.log("meberID---->", memberId);

  console.log("priviousData---->", previousData);
  const [kycData, setKycData] = useState({
    member_pan: "",
    member_aadhar: "",
    member_account: "",
    member_ifsc: "",
  });

  const [images, setImages] = useState({
    panFront: null,
    panBack: null,
    aadharFront: null,
    aadharBack: null,
    cheque:null,
    gst: null,
  });

  // Validation functions
  const validatePAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);
  const validateAadhar = (aadhar) => /^\d{12}$/.test(aadhar);
  const validateAccountNumber = (acc) => /^\d{9,18}$/.test(acc);
  const validateIFSC = (ifsc) =>
    /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc.toUpperCase());

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only allow digits for account number field
    if (name === "member_account") {
      // Remove any non-digit characters
      const cleanedValue = value.replace(/\D/g, "");
      setKycData({ ...kycData, [name]: cleanedValue });
    } else if (name === "member_aadhar") {
      // Only digits for Aadhaar too (optional improvement)
      const cleanedValue = value.replace(/\D/g, "");
      setKycData({ ...kycData, [name]: cleanedValue });
    } else {
      setKycData({ ...kycData, [name]: value });
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const handleImageChange = async (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setImages((prev) => ({ ...prev, [field]: URL.createObjectURL(file) }));
      // setKycData((prev) => ({ ...prev, [field]: file }));
      setErrors((prev) => ({ ...prev, [field]: "" }));

      if (field === "panFront" && memberId) {
        try {
          const resultAction = await dispatch(
            uploadPanFront({ member_id: memberId, file })
          );
          if (uploadPanFront.fulfilled.match(resultAction)) {
            setUploadStatuspan(true);
            console.log("✅ PAN Front Upload Response:", resultAction.payload);
          } else {
            console.error("❌ PAN Front Upload Failed:", resultAction.payload);
          }
        } catch (error) {
          console.error("❌ PAN Front Upload Error:", error);
        }
      }

      if (field === "panBack" && memberId) {
        try {
          const resultAction = await dispatch(
            uploadPanBack({ member_id: memberId, file })
          );
          if (uploadPanBack.fulfilled.match(resultAction)) {
            setUploadStatuspan2(true);
            console.log("✅ back Upload Response:", resultAction.payload);
          } else {
            console.error("❌ PAN back Upload Failed:", resultAction.payload);
          }
        } catch (error) {
          console.error("❌ PAN back Upload Error:", error);
        }
      }

      if (field === "aadharFront" && memberId) {
        try {
          const resultAction = await dispatch(
            uploadAadharFront({ member_id: memberId, file })
          );
          if (uploadAadharFront.fulfilled.match(resultAction)) {
            setuploadAadhar(true);
            console.log(
              "✅  AAdhar card Front Upload Response:",
              resultAction.payload
            );
          } else {
            console.error(
              "❌ AAdhar card Front Upload Failed:",
              resultAction.payload
            );
          }
        } catch (error) {
          console.error("❌ Aadhar Card Upload Error:", error);
        }
      }

      if (field === "aadharBack" && memberId) {
        try {
          const resultAction = await dispatch(
            uploadAadharBack({ member_id: memberId, file })
          );
          if (uploadAadharBack.fulfilled.match(resultAction)) {
            setuploadAadhar2(true);
            console.log(
              "✅  AAdhar card back Upload Response:",
              resultAction.payload
            );
          } else {
            console.error(
              "❌ AAdhar card back Upload Failed:",
              resultAction.payload
            );
          }
        } catch (error) {
          console.error("❌ Aadhar Card  back Upload Error:", error);
        }
      }
      if (field === "cheque" && memberId) {
        try {
          const resultAction = await dispatch(
            uploadCheque({ member_id: memberId, file })
          );
          if (uploadCheque.fulfilled.match(resultAction)) {
            setuploadChequeBook(true);
            console.log(
              "✅  AAdhar card back Upload Response:",
              resultAction.payload
            );
          } else {
            console.error(
              "❌ AAdhar card back Upload Failed:",
              resultAction.payload
            );
          }
        } catch (error) {
          console.error("❌ Aadhar Card  back Upload Error:", error);
        }
      }
    }
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!kycData.member_pan)
  //     newErrors.member_pan = "PAN card number is required";
  //   if (!kycData.member_aadhar)
  //     newErrors.member_aadhar = "Aadhaar number is required";
  //   if (!kycData.member_account)
  //     newErrors.member_account = "Account number is required";
  //   if (!kycData.member_ifsc) newErrors.member_ifsc = "IFSC code is required";

  //   // ["panFront", "panBack", "aadharFront", "aadharBack"].forEach((field) => {
  //   //   if (!kycData[field]) newErrors[field] = `${field} image is required`;
  //   // });

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validateForm = () => {
    const newErrors = {};
    if (!kycData.member_pan) {
      newErrors.member_pan = "PAN card number is required";
    } else if (!validatePAN(kycData.member_pan)) {
      newErrors.member_pan = "Invalid PAN card number format (e.g. ABCDE1234F)";
    }

    if (!kycData.member_aadhar) {
      newErrors.member_aadhar = "Aadhaar number is required";
    } else if (!validateAadhar(kycData.member_aadhar)) {
      newErrors.member_aadhar = "Invalid Aadhaar number format (12 digits)";
    }

    if (!kycData.member_account) {
      newErrors.member_account = "Account number is required";
    } else if (!validateAccountNumber(kycData.member_account)) {
      newErrors.member_account = "Invalid Account number (12 digit)";
    }

    if (!kycData.member_ifsc) {
      newErrors.member_ifsc = "IFSC code is required";
    } else if (!validateIFSC(kycData.member_ifsc)) {
      newErrors.member_ifsc = "Invalid IFSC code format (e.g. SBIN0001234)";
    }

    // Optional: You can still validate images if needed
    // ["panFront", "panBack", "aadharFront", "aadharBack"].forEach((field) => {
    //   if (!images[field]) newErrors[field] = `${field} image is required`;
    // });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const finalData = { ...previousData, ...kycData };

    // Object.entries({ ...previousData, ...kycData }).forEach(([key, value]) => {
    //   finalData.append(key, value);
    // });

    try {
      await dispatch(updateMember(finalData)).unwrap();
      // localStorage.removeItem("companyStep1");
      // localStorage.removeItem("companyStep2");
      navigate("/successpage");
    } catch (err) {
      console.error("Registration failed:", err);
      alert("Something went wrong. Please try again.");
      // localStorage.removeItem("companyStep1");
      // localStorage.removeItem("companyStep2");
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setMemberId(parsedUser.member_id);
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }
    }
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="stepper_root">
        <Stepper currentStep={2} />
      </div>
      <div className="kyc-container">
        <form className="kyc-form" onSubmit={handleSubmit}>
          {/* PAN Number */}
          <div className="form-group">
            <label>PAN Card Number </label>
            <input
              type="text"
              name="member_pan"
              placeholder="Enter PAN card number"
              value={kycData.member_pan}
              onChange={handleChange}
              className={errors.member_pan ? "error-border" : ""}
            />

            {errors.member_pan && (
              <span className="error-text">{errors.member_pan}</span>
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontSize: "17px", fontWeight: "bold" }}>
              Upload PAN Image
            </p>
          </div>

          <div className="flex_track">
            {/* PAN Front */}
            <div className="upload-box">
              <label style={{ fontSize: "14px" }}> Front Side </label>
              <div className="image-preview">
                {images.panFront ? (
                  <img src={images.panFront} alt="Pan Front" />
                ) : (
                  <div>
                    <ImageUp size={24} color="#3D90D7" />
                    <span className="upload-text"> Upload Image</span>
                  </div>
                )}
              </div>
              <div className="upload-btn-align">
                {uploadStatuspan ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, panFront: null }));
                        setUploadStatuspan(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "panFront")}
                    />
                  </div>
                )}
              </div>
              {errors.panFront && (
                <span className="error-text">{errors.panFront}</span>
              )}
            </div>
            {/* PAN Back */}
            <div className="upload-box">
              <label style={{ fontSize: "14px" }}> Back Side </label>
              <div className="image-preview">
                {images.panBack ? (
                  <img src={images.panBack} alt="Pan Back" />
                ) : (
                  <div>
                    <ImageUp size={24} color="#3D90D7" />
                    <span className="upload-text"> Upload Image</span>
                  </div>
                )}
              </div>

              <div className="upload-btn-align">
                {uploadStatuspan2 ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, panBack: null }));
                        setUploadStatuspan2(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "panBack")}
                    />
                  </div>
                )}
              </div>
              {errors.panBack && (
                <span className="error-text">{errors.panBack}</span>
              )}
            </div>
          </div>
          {/* Aadhaar Number */}
          <div className="form-group" style={{ marginTop: "20px" }}>
            <label>Aadhaar Number</label>
            <input
              type="text"
              name="member_aadhar"
              placeholder="Enter Aadhaar number"
              value={kycData.member_aadhar}
              onChange={handleChange}
              className={errors.member_aadhar ? "error-border" : ""}
              maxLength={12}
            />

            {errors.member_aadhar && (
              <span className="error-text">{errors.member_aadhar}</span>
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontSize: "17px", fontWeight: "bold" }}>
              Upload Aadhar Image
            </p>
          </div>

          <div className="flex_track">
            {/* Aadhar Front */}
            <div className="upload-box">
              <label style={{ fontSize: "14px" }}> Front Side </label>
              <div className="image-preview">
                {images.aadharFront ? (
                  <img src={images.aadharFront} alt="Aadhar Front" />
                ) : (
                  <div>
                    <ImageUp size={24} color="#3D90D7" />
                    <span className="upload-text"> Upload Image</span>
                  </div>
                )}
              </div>

              <div className="upload-btn-align">
                {uploadAadhar ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, aadharFront: null }));
                        setuploadAadhar(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "aadharFront")}
                      className="btn_file_upload"
                    />
                  </div>
                )}
              </div>
              {/* {uploadAadhar && (
                <div className="sector_succesfull">
                  <span>
                    {" "}
                    <ShieldTick size="42" color="#145a32" variant="Bold" />
                  </span>
                  <p className="txt_trck"> Upload Successful</p>
                </div>
              )} */}

              {errors.aadharFront && (
                <span className="error-text">{errors.aadharFront}</span>
              )}
            </div>

            {/* Aadhar Back */}
            <div className="upload-box">
              <label style={{ fontSize: "14px" }}> Back Side </label>
              <div className="image-preview">
                {images.aadharBack ? (
                  <img src={images.aadharBack} alt="Aadhar Back" />
                ) : (
                  <div>
                    <ImageUp size={24} color="#3D90D7" />
                    <span className="upload-text"> Upload Image</span>
                  </div>
                )}
              </div>

              <div className="upload-btn-align">
                {uploadAadhar2 ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, aadharBack: null }));
                        setuploadAadhar2(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "aadharBack")}
                    />
                  </div>
                )}
              </div>
              {errors.aadharBack && (
                <span className="error-text">{errors.aadharBack}</span>
              )}
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontSize: "17px", fontWeight: "bold" }}>
              Upload Cheque Image
            </p>
          </div>

          <div className="flex_track">
              {/* CHEQUE BOOK */}
            <div className="upload-box">
              <label style={{ fontSize: "14px" }}> Front  (Cheque Book) </label>
              <div className="image-preview">
                {images.cheque ? (
                  <img src={images.cheque} alt="Cheque Book" />
                ) : (
                  <div>
                    <ImageUp size={24} color="#3D90D7" />
                    <span className="upload-text"> Upload Image</span>
                  </div>
                )}
              </div>

              <div className="upload-btn-align">
                {uploadChequeBook ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, cheque: null }));
                        setuploadChequeBook(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "cheque")}
                    />
                  </div>
                )}
              </div>
              {errors.aadharBack && (
                <span className="error-text">{errors.aadharBack}</span>
              )}
            </div>
          </div>

          {/* GST */}
          {/* <div className="upload-box">
              <label>GST</label>
              <div className="image-preview">
                {images.gst ? (
                  <img src={images.gst} alt="GST" />
                ) : (
                  <span>
                    <ImageUp size={24} color="#bdc3c7" /> Upload Image
                  </span>
                )}
              </div>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageChange(e, "gst")}
              />
              {errors.gst && <span className="error-text">{errors.gst}</span>}
            </div> */}

          {/* Bank Details */}
          <h4>Bank Details</h4>
          <div className="form-group">
            <label>Account Number </label>
            <input
              type="text"
              name="member_account"
              placeholder="Enter account number"
              value={kycData.member_account}
              onChange={handleChange}
              className={errors.member_account ? "error-border" : ""}
              maxLength={12}
            />
            {errors.member_account && (
              <span className="error-text">{errors.member_account}</span>
            )}
          </div>

          <div className="form-group">
            <label>IFSC Code </label>
            <input
              type="text"
              name="member_ifsc"
              placeholder="Enter IFSC code"
              value={kycData.member_ifsc}
              onChange={handleChange}
              className={errors.member_ifsc ? "error-border" : ""}
            />
            {errors.member_ifsc && (
              <span className="error-text">{errors.member_ifsc}</span>
            )}
          </div>

          <div className="form-btn">
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Proceed"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default KYCDetailsFormMr;
